import React from 'react';

import Header from '../../containers/Header/Header.js';
import './HeaderSection.css';

const HeaderSection = (props) => {
   return (
     <div className="HeaderSection-container">
       
       <Header />
       {/* <Placeholder {...props} />   */}
     </div>
   )
 }
 
 export default HeaderSection;


// WEBPACK FOOTER //
// ./src/containers/HeaderSection/HeaderSection.js